import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./ForgotPassword.module.css";
import logo from "../../../assets/images/logo.png";
import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { validateForm } from "../../../utills/Validators";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
function ForgetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [role, setRole] = useState({ value: "Dealership", id: 1 });

  const formState = [{ key: "Email", value: email }];
  const onForgotPass = () => {
    let userdata = {
      // role: role.value.toLowerCase(),
      email,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else {
      dispatch(AuthMiddleware.forgetPassword(userdata))
        .then(() =>
          navigate("/verifyCode", {
            state: { screen: "forgot", role: role?.value, email },
          }),
        )
        .catch(() => {});
    }

    // ✅ Proceed with actual sign-up logic
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline />
            <TextComponent text={"Back to login"} />
          </div>
          <div className={styles.textDiv}>
            <TextComponent
              className={styles.welcomeHeading}
              text={"Forgot Password?"}
            />
            <TextComponent
              className={styles.welcomeText}
              text={"Please enter your email address to get verification code."}
            />
          </div>
          <div className={styles.inputDiv}>
            <InputField
              className={styles.input}
              label={"Email Address"}
              placeholder={"chris@email.com"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* <Dropdown
              className={styles.input}
              label={"Role"}
              value={role}
              labelStyle={{ color: "#838383", fontSize: 18 }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Dealership",
                  id: 1,
                },
                { value: "Dealership-Staff", id: 3 },
                {
                  value: "Customer",
                  id: 2,
                },
              ]}
              onChange={(e) => setRole(e)}
            /> */}
          </div>
          <div className={styles.btn} onClick={onForgotPass}>
            <SubmitButton title={"Get Code"} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
